// extracted by mini-css-extract-plugin
export default {"root":"IconReview_root__NKoeS","filled":"IconReview_filled__6FMRE"};